import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { Events } from './StoreDropdown'

export const STATES = {
    ACTIVE: 'is-active',
    MOBILE: 'is-mobile-active',
}

export default class StoreDropdownToggle extends Component {
    prepare() {
        this.element.addEventListener('click', this.handleClick)
        EventBus.on(Events.Open, this.handleOpen)
        EventBus.on(Events.Close, this.handleClose)
    }

    destroy() {
        EventBus.off(Events.Open, this.handleOpen)
        EventBus.off(Events.Close, this.handleClose)
    }

    handleClick = (event) => {
        const component = Component.getFromElement(this.element.getAttribute('aria-controls'))

        if (component) {
            event.preventDefault()
            event.stopPropagation()
            component.toggle()
        }
    }

    handleOpen = () => {
        this.element.classList.add(STATES.ACTIVE)
        this.element.classList.add(STATES.MOBILE)
        this.element.setAttribute('aria-selected', 'true')
    }

    handleClose = () => {
        this.element.classList.remove(STATES.ACTIVE)
        this.element.classList.remove(STATES.MOBILE)
        this.element.setAttribute('aria-selected', 'false')
    }
}
